export interface Theme {
  id: 'midnight' | 'paper';
  name: string;
  className: string;
  mode: 'dark' | 'light';
}

export const DARK_THEME: Theme = {
  id: 'midnight',
  name: 'Midnight Indigo',
  className: 'theme-midnight',
  mode: 'dark',
};

export const LIGHT_THEME: Theme = {
  id: 'paper',
  name: 'Light Paper',
  className: 'theme-paper',
  mode: 'light',
};

export const THEMES = [DARK_THEME, LIGHT_THEME] as const;

/** User-facing mode preference. Auto = follow OS via prefers-color-scheme. */
export type ModePref = 'auto' | 'light' | 'dark';

export const DEFAULT_MODE: ModePref = 'auto';

export const resolveTheme = (pref: ModePref, systemDark: boolean): Theme => {
  const effective = pref === 'auto' ? (systemDark ? 'dark' : 'light') : pref;
  return effective === 'dark' ? DARK_THEME : LIGHT_THEME;
};
